import FAQPanel from '#root/components/FAQPanel';
import type { FAQItem } from '#root/components/FAQPanel';
import { Timeline } from '#root/components/ui';
import * as VARIABLES from '#root/constants/variables';
import styles from './couponInfoPanel.module.scss';

const faqs: FAQItem[] = [
  {
    id: 'generar',
    question: '¿Cómo genero un cupón?',
    answer: (
      <>
        <p>
          Genera tu cupón desde{' '}
          <a
            href={VARIABLES.URL_PHP_PAGE + 'cupones'}
            target="_blank"
            rel="noopener noreferrer">
            www.guvery.com/cupones
          </a>{' '}
          y guarda el código generado.
        </p>
        <p>
          <small>También recibirás un correo con tu cupón y el código generado.</small>
        </p>
      </>
    ),
  },
  {
    id: 'usar',
    question: '¿Cómo uso un cupón?',
    answer: (
      <Timeline
        variant="numbered"
        items={[
          'Ingresa a tu pedido o acuerdo de Guvery',
          'Al momento de pagar, verás un campo "Aplicar Cupón"',
          'Ingresa el código y presiona el botón para validarlo',
          'El monto total se ajustará automáticamente',
        ]}
      />
    ),
  },
  {
    id: 'servicios',
    question: '¿Qué tipos de cupones hay?',
    answer: (
      <ul>
        <li>
          <strong>Guvery Regular:</strong> Aplica a pedidos del servicio Regular (pagas después del acuerdo)
        </li>
        <li>
          <strong>Guvery ONE:</strong> Aplica a pedidos del servicio ONE (pagas al inicio)
        </li>
      </ul>
    ),
  },
  {
    id: 'condiciones',
    question: '¿Qué condiciones tienen los cupones?',
    answer: (
      <ul>
        <li>Revisa el servicio (Regular u ONE) antes de usar el cupón</li>
        <li>Los cupones pueden tener fecha de vencimiento</li>
        <li>Algunos cupones tienen un límite de usos en la comunidad</li>
        <li>El descuento tiene un monto máximo aplicable</li>
      </ul>
    ),
  },
];

const CouponInfoPanel = () => {
  return (
    <div className={styles.root}>
      <FAQPanel
        faqs={faqs}
        subtitle="Mis Cupones"
        teaserText="Información sobre cómo generar, usar o aplicar cupones."
      />
    </div>
  );
};

export default CouponInfoPanel;
